import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpLoaderOverlayComponent } from './shared/loader/http-loader-overlay.component';

@Component({
  selector: 'unip-root',
  standalone: true,
  imports: [RouterOutlet, HttpLoaderOverlayComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent { }
